/**
 * Campo de formulário padrão do admin: label acima, obrigatório com *,
 * espaço para hint/erro abaixo. Usado nos formulários redesenhados.
 */

export const inputClasses =
    "rounded-lg border border-primary/40 bg-mgs-surface px-3 py-1.5 text-laranjinha placeholder-laranjinha/30 outline-none focus:border-primary disabled:cursor-not-allowed disabled:opacity-50";

export const Field = ({ label, required, hint, className = "", children }) => (
    <label className={`flex flex-col gap-1 text-left text-sm text-laranjinha/70 ${className}`}>
        <span>
            {label}
            {required ? <span className="text-primary"> *</span> : null}
        </span>
        {children}
        {hint ? <span className="text-xs text-laranjinha/40">{hint}</span> : null}
    </label>
);

export default Field;
